/**
 * @file _common.js
 */
'use strict';

/**
 * @classname Common
 */

export default class Common {

	/**
	 * @constructor
	 */
	constructor() {
		console.log('Common.constructor');
	};


	/**
	 * 機種判定を行う
	 *
	 * @memberof Common
	 * @return {undefined}
	 */
	static addHtmlClass() {
		console.log('Common.addHtmlClass');
		let ua = window.navigator.userAgent.toLowerCase();
		let ver = window.navigator.appVersion.toLowerCase();

		let browser, device;
		if (ua.indexOf('edge') !== -1) {
			browser = 'edge';
		} else if (ua.indexOf('chrome') !== -1 && ua.indexOf('edge') === -1) {
			browser = 'chrome';
		} else if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
			browser = 'safari';
		} else if (ua.indexOf('opera') !== -1) {
			browser = 'opera';
		} else if (ua.indexOf('firefox') !== -1) {
			browser = 'firefox';
		}

		if (ua.indexOf('iphone') !== -1 || ua.indexOf('ipod') !== -1) {
			device = 'iphone';
		} else if (ua.indexOf('ipad') !== -1) {
			device = 'ipad';
		} else if (ua.indexOf('android') !== -1) {
			device = 'android';
		}

		if (browser) $('html').addClass(browser);
		if (device) $('html').addClass(device);
	}
}
